import { Box, Flex, VStack } from "@chakra-ui/react";
import { PaddedOnMobile } from "@components/site/layout";
import CollabsSection from "@components/site/pricing/CollabsSection";
import PricingTiersSection from "@components/site/pricing/PricingTiersSection";
import QuestionsSection from "@components/site/pricing/QuestionsSection";
import { useWindowSiteStore } from "@store/windowSiteStore";
import { scale } from "@utils/helpers";
import { GetServerSidePropsContext } from "next";
import { getServerSession } from "next-auth";
import Head from "next/head";
import { createAuthOptions } from "./api/auth/[...nextauth]";

type PricingPageProps = {};

export const PricingPage = ({}: PricingPageProps) => {
    const isDesktop = useWindowSiteStore((state) => state.isDesktop);
    const windowWidth = useWindowSiteStore((state) => state.windowWidth);

    const minSize = isDesktop ? 960 : 375;
    const maxSize = isDesktop ? 1200 : 960;

    return (
        <>
            <Head>
                <title key="title">Beyond Rarity - Pricing</title>
            </Head>
            <PaddedOnMobile>
                <VStack w="100%" gap={scale(windowWidth, minSize, maxSize, 30, 50) + "px"}>
                    <Flex direction="column" textAlign="center">
                        <Box
                            fontFamily="regular"
                            fontSize={scale(windowWidth, minSize, maxSize, 36, 48)}
                            lineHeight="110%"
                        >
                            Pricing
                        </Box>
                        <Box
                            fontSize={scale(windowWidth, minSize, maxSize, 18, 24)}
                            fontWeight="light"
                        >
                            Join more than 5,000 other NFT enthusiasts in our ecosystem.
                        </Box>
                    </Flex>

                    <PricingTiersSection />
                </VStack>
            </PaddedOnMobile>

            <CollabsSection />

            <QuestionsSection />
        </>
    );
};

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
    return {
        props: {
            session: await getServerSession(ctx.req, ctx.res, createAuthOptions()),
        },
    };
}

export default PricingPage;
